<template>
	<div class="intro-cycle">
		<button
			class="intro-nav prev mask"
			v-on:click="dec();progressAuto=false"
			aria-label="Previous image in carousel"
		></button>
		<button
			class="intro-nav next mask"
			v-on:click="inc();progressAuto=false"
			aria-label="Next image in carousel"
		></button>

		<div class="mask-bgs">
			<div
				class="maskbg"
				v-for="(choice, ichoice) in choices"
				v-bind:key="ichoice"
				:class="{
					'active': activeItem === ichoice,
					'leaving': leavingItem === ichoice && timerActive,
					'mask-20s' : choice.decade === '1920',
					'mask-30s' : choice.decade === '1930',
					'mask-40s' : choice.decade === '1940',
					'mask-50s' : choice.decade === '1950',
					'mask-60s' : choice.decade === '1960',
					'mask-70s' : choice.decade === '1970',
					'mask-80s' : choice.decade === '1980',
					'mask-90s' : choice.decade === '1990',
					'mask-2000s' : choice.decade === '2000',
					'mask-2010s' : choice.decade === '2010',
				}"
			>
				<div class="bgEl only-dt" v-if="choice.imgFull !== '' && choice.vidURL === '' && stageLoad(ichoice)" v-bind:style="'background-image:url(\'' + pathToMedia +choice.imgFull+'\')'"></div>
				<div class="bgEl only-mob" v-if="choice.imgFull !== '' && choice.vidURL === '' && stageLoad(ichoice)" v-bind:style="'background-image:url(\'' + pathToMedia +choice.imgMobile+'\')'"></div>
				<video :src="choice.vidURL" :poster="pathToMedia +choice.imgFull" v-if="choice.vidURL !== '' && stageLoad(ichoice)" autoplay loop muted playsinline></video>
				<div class="feature-row-mask" v-bind:class="{
					'decade-1920' : choice.decade === '1920',
					'decade-1930' : choice.decade === '1930',
					'decade-1940' : choice.decade === '1940',
					'decade-1950' : choice.decade === '1950',
					'decade-1960' : choice.decade === '1960',
					'decade-1970' : choice.decade === '1970',
					'decade-1980' : choice.decade === '1980',
					'decade-1990' : choice.decade === '1990',
					'decade-2000' : choice.decade === '2000',
					'decade-2010' : choice.decade === '2010',
					'intro-gone':headerpos!=='intro'
				}" v-html="choice.text"></div>
			</div>

		</div>
	</div>
</template>

<script>
var inView = require("in-view");
var $ = require('jquery');
export default {
	data() {
		return {
			initialItem:null,
			activeItem: null,
			leavingItem: null,
			aniTimer: 0,
			timerActive:false,
			timerTimer:null,
			request: null,
			progressAuto:true,
			pathToMedia:'/interactives/moma_through_time/static/uploads'
		};
	},
	props: ["choices","rootPath","headerpos"],
	created() {
		// set total items
		// console.log(this.choices);
		//flag switch
		this.pathToMedia = this.rootPath+'static/uploads';
		// this.pathToMedia = 'http://54.87.134.1/wp-content/uploads';
	},
	mounted() {
		let introThis = this;
		// console.log(this.choices);
		setTimeout(function() {
		// 	introThis.inc();
			introThis.activeItem = 9;
		}, 500);
		requestAnimationFrame(introThis.performAnimation);
		this.bindClicks();
		inView(".intro-cycle")
			// .on('enter', el => {
			.on("enter", function() {
				cancelAnimationFrame(introThis.request);
				requestAnimationFrame(introThis.performAnimation);
			})
			.on("exit", function() {
				cancelAnimationFrame(introThis.request);
			});
	},
	methods: {
		bindClicks:function(){
			$(".feature-row-mask a").not('.link-init').each(function(){
				$(this).addClass("link-init");
				$(this).on("click",function(e){
					let tempURL = $(this).data("slug");
					let tempOutURL = $(this).attr("href");
					if(tempURL && $(".article-"+tempURL).hasClass("article-"+tempURL)){
						e.preventDefault();
						// console.log("found it");
						let newOffset = $(".article-"+tempURL).offset().top;
						$(".article-"+tempURL).addClass("autoload");
						window.scrollTo(0, newOffset);
						// console.log(newOffset);
						var stateObj = {
							pageroute: tempOutURL
						};

						history.pushState(stateObj, tempOutURL, tempOutURL);
					}
					// console.log(tempURL);

					return false;
				});
			});
		},
		stageLoad(choice){
			if(this.activeItem - choice >= -1 && this.activeItem - choice <= 1){
				return true;
			} else {
				return false;
			}
		},
		performAnimation() {
			let scopeThis = this;
			if(scopeThis.progressAuto){
				scopeThis.request = requestAnimationFrame(
					scopeThis.performAnimation
				);
				scopeThis.draw();
			}
		},
		draw() {
			if (this.aniTimer >= 500) {
				this.inc();
			}
			this.aniTimer = this.aniTimer + 1;
		},
		inc() {
			let temp = this.activeItem + 1;
			if(temp >= this.choices.length){
				temp = 0;
			}
			this.leavingItem = this.activeItem;
			this.activeItem = null;
			this.activeItem = temp;
			this.aniTimer = 0;
			let timeThis = this;
			timeThis.timerActive = true;
			clearTimeout(timeThis.timerTimer);
			timeThis.timerTimer = setTimeout(function(){
				timeThis.timerActive = false;
				timeThis.bindClicks();
			},1000);
		},
		dec() {
			let temp = this.activeItem - 1;
			if(temp < 0){
				temp = this.choices.length - 1;
			}
			this.leavingItem = this.activeItem;
			this.activeItem = null;
			this.activeItem = temp;
			this.aniTimer = 0;
			let timeThis = this;
			timeThis.timerActive = true;
			clearTimeout(timeThis.timerTimer);
			timeThis.timerTimer = setTimeout(function(){
				timeThis.timerActive = false;
				timeThis.bindClicks();
			},1000);
		}
	},
	watch:{
		activeItem:function(newValue){
			let decadeRef = this.choices[newValue].decade;
			let newIndex = null;
			if(decadeRef === '1920'){
				newIndex = 0;
			} else if(decadeRef === '1930'){
				newIndex = 1;
			} else if(decadeRef === '1940'){
				newIndex = 2;
			} else if(decadeRef === '1950'){
				newIndex = 3;
			} else if(decadeRef === '1960'){
				newIndex = 4;
			} else if(decadeRef === '1970'){
				newIndex = 5;
			} else if(decadeRef === '1980'){
				newIndex = 6;
			} else if(decadeRef === '1990'){
				newIndex = 7;
			} else if(decadeRef === '2000'){
				newIndex = 8;
			} else if(decadeRef === '2010'){
				newIndex = 9;
			}
			if(newIndex !== null){
				this.$root.$data.introActive = newIndex;
			}
		},
		progressAuto:function(newValue){
			this.$root.$data.introAuto = newValue;
		}
	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
@mixin headerstyle {
	font-size: 32px;
	font-weight: 600;
	@include tabletBelow {
		font-size: 20px;
	}
}
@mixin headerclassify {
	font-size: 20px;
	font-weight: 400;
	@include tabletBelow {
		font-size: 16px;
	}
}
.only-dt {
	@include tabletBelow {
		display:none !important;
	}
}
.only-mob {
	display:none;
	@include tabletBelow {
		display:block;
	}
}
.intro-cycle {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 2;
	button:focus {
		outline:none;
		box-shadow: none;
	}
}
.intro-nav {
	position: absolute;
	top: 50%;
	width: 60px;
	height: 60px;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: 30px 30px;
	margin-top: -30px;
	transition-duration: 1s;
	cursor: pointer;
	background: none;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	border: none;
	&.prev {
		left: 20px;
		background-image: url(../assets/arr-left@2x.png);
		background-size:30px auto;
		@include tabletBelow {
			left: 0;
			background-size: 40% auto;
			background-position: 38% 50%;
		}
	}
	&.next {
		right: 20px;
		background-image: url(../assets/arr-right@2x.png);
		background-size:30px auto;
		@include tabletBelow {
			right: 0;
			background-size: 40% auto;
			background-position: 62% 50%;
		}
	}
	@include tabletBelow {
		top: auto;
		bottom: 85px;
		width:40px;
		height:40px;
	}
}
.mask-bgs {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	height: 100vh;
	z-index: -1;
	.maskbg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		transition-duration: 0.8s;
		transition-property: clip-path;
		opacity: 0;
		animation: fadein 0.5s linear forwards;
		backface-visibility: hidden;
		background:black;
		transition-timing-function: cubic-bezier(0.6, 0, 1, 1);
		// background: black;
		.bgEl {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-size: cover;
			background-position: 50% 50%;
			opacity: 0.6;
			z-index: 1;
			//display:none; // temp hide for meeting
			&:after {
				content: "";
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 250px;
				pointer-events: none;
				z-index: 4;
				background: -moz-linear-gradient(
					bottom,
					rgba(0, 0, 0, 0.5) 0%,
					rgba(0, 0, 0, 0) 100%
				); /* FF3.6-15 */
				background: -webkit-linear-gradient(
					bottom,
					rgba(0, 0, 0, 0.5) 0%,
					rgba(0, 0, 0, 0) 100%
				); /* Chrome10-25,Safari5.1-6 */
				background: linear-gradient(
					to top,
					rgba(0, 0, 0, 0.5) 0%,
					rgba(0, 0, 0, 0) 100%
				); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			}
			@include tabletBelow {
				&:after {
					content: "";
					position: absolute;
					bottom: 0;
					left: 0;
					width: 100%;
					height: 250px;
					z-index: 4;
					pointer-events:none;
					background: -moz-linear-gradient(
						bottom,
						rgba(0, 0, 0, 0.5) 0%,
						rgba(0, 0, 0, 0) 100%
					); /* FF3.6-15 */
					background: -webkit-linear-gradient(
						bottom,
						rgba(0, 0, 0, 0.5) 0%,
						rgba(0, 0, 0, 0) 100%
					); /* Chrome10-25,Safari5.1-6 */
					background: linear-gradient(
						to top,
						rgba(0, 0, 0, 0.5) 0%,
						rgba(0, 0, 0, 0) 100%
					); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
				}
			}
		}
		&.leaving {
			z-index: 2;
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
			transition-duration: 0s;
		}
		&.active {
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
			z-index: 5;
		}
	}
}
.mask-20s {
	clip-path: polygon(5% 0, 5% 0, 5% 100%, 5% 100%);
}
.mask-30s {
	clip-path: polygon(15% 0, 15% 0, 15% 100%, 15% 100%);
}
.mask-40s {
	clip-path: polygon(25% 0, 25% 0, 25% 100%, 25% 100%);
}
.mask-50s {
	clip-path: polygon(35% 0, 35% 0, 35% 100%, 35% 100%);
}
.mask-60s {
	clip-path: polygon(45% 0, 45% 0, 45% 100%, 45% 100%);
}
.mask-70s {
	clip-path: polygon(55% 0, 55% 0, 55% 100%, 55% 100%);
}
.mask-80s {
	clip-path: polygon(65% 0, 65% 0, 65% 100%, 65% 100%);
}
.mask-90s {
	clip-path: polygon(75% 0, 75% 0, 75% 100%, 75% 100%);
}
.mask-2000s {
	clip-path: polygon(85% 0, 85% 0, 85% 100%, 85% 100%);
}
.mask-2010s {
	clip-path: polygon(95% 0, 95% 0, 95% 100%, 95% 100%);
}

.feature-row-mask {
	position: absolute;
	bottom: 120px;
	@include aboveTablet {
		bottom: 90px;
	}
	left: 0;
	right: 0;
	opacity: 0;
	pointer-events: none;
	z-index:2;
	backface-visibility: hidden;
	@include headerstyle;
	transition-duration: 0.15s;
	transition-timing-function: ease-in;
	text-align: center;
	@media (min-width: 1230px) {
		font-size: 3vw;
	}
	@media (min-width: 1500px) {
		font-size: 44px;
	}
	@include tabletBelow {
		padding-left: 50px;
		padding-right: 50px;
		font-size: 26px;
		line-height: 1.3;
		vertical-align: middle;
		bottom: 130px;
		transform: translateY(50%);
	}
	.active & {
		opacity: 1;
		transition-duration: 0.3s;
		transition-timing-function: ease-out;
		// transition-delay:0.3s;
		pointer-events: all;
	}
	&.intro-gone {
		opacity:0;
		transition-delay:0.3s;
	}
	.scroll-triggered & {
		opacity: 0;
		transition-delay: 0s;
	}

	a {
		text-decoration: none;
		color: var(--coloractive, inherit);
		border-bottom: solid 3px;
		border-color: var(--coloractive, inherit);
	}
	.classify {
		@include headerclassify;
		margin-top: 10px;
		@include tabletBelow {
			position: absolute;
			left: 0;
			width: 100%;
		}
	}
}
.intro-cycle {
	video {
		position:absolute;
		top:50%;
		left:50%;
		width:100%;
		height:100%;
		object-fit:cover;
		transform:translateX(-50%) translateY(-50%) translateZ(0);
		z-index:1;
		backface-visibility: hidden;
		pointer-events:none;
		opacity:0;
		transition-property:opacity;
		transition-duration:0.3s;

	}
	.leaving video { opacity:0; }
	.active video {opacity:1;}
}
</style>
